import * as parameters from './parameters';
import * as itemGroups from './itemGroups';
import * as items from './items';
import * as tagGroups from './tagGroups';
import * as users from './users';
import * as profiles from './profiles';
import * as history from './history';

export { parameters, itemGroups, items, tagGroups, users, profiles, history };



// WEBPACK FOOTER //
// ./src/services/api/admin/index.ts